import { ExternalEnum } from '@enums/route-enum';
import Enumeration from './enum';

const CampaignEnum = new Enumeration({
  CAMPAIGN: 'ld_campaign',
  CAMPAIGN_NAME: 'smartgroup-staff',
  CAMPAIGN_DURATION_IN_DAYS: 365,
});

function getCampaign(company) {
  return {
    CAMPAIGN: CampaignEnum.CAMPAIGN,
    CAMPAIGN_NAME: company ? `smartgroup-${company}` : CampaignEnum.CAMPAIGN_NAME,
    CAMPAIGN_DURATION_IN_DAYS: CampaignEnum.CAMPAIGN_DURATION_IN_DAYS,
  };
}

function getCtaHref() {
  return ExternalEnum.CONCIERGE.href;

  /*
  const slug = company ? `smartgroup-${company}` : CampaignEnum.CAMPAIGN_NAME;

  return `${process.env.VUE_APP_CREATE_ENQUIRY_URL}?slug=${slug}`;
  */
}

export default CampaignEnum;
export { getCtaHref, getCampaign };
